<template>
  <div>
    <b-card title="Hoşgeldiniz">
      <b-row>
        <b-col cols="12">
          Ajans Bulut içerik yönetim sistemine hoşgeldiniz.
          <div class="text-muted font-small-2">
            Ajans Bulut CMS
          </div>
        </b-col>
      </b-row>

    </b-card>
    <b-card
        :title="dataCounts.toString()+' adet proje bulunmaktadır.'"
        img-src="https://demos.creative-tim.com/argon-dashboard-pro-bs4/assets/img/theme/img-1-1000x600.jpg"
        img-alt="Image"
        img-top
        tag="article"
        style="max-width: 20rem;"
        class="mb-2"
    >
      <b-button
          href="javascript:;"
          variant="primary"
          :to="{ path: '/app/projects' }" >Projelere git
      </b-button>
    </b-card>
  </div>


</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue';
import {localize} from "vee-validate";
import dataList from "@/views/Admin/Translate/DataList.vue";

export default {
  name: 'Manager',

  components: {
    BButton,
    BCard,
    BRow,
    BCol,
  },

  computed: {
    dataList() {
      return dataList
    },
//getter'lardan gelen veriler döndürülür
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title'
        ],

      })
    },
  },
}
</script>
